import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../api/client";

export default function ForgotPasswordPage() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [step, setStep] = useState(params.get("email") ? 2 : 1);
  const [form, setForm] = useState({
    email: params.get("email") || "",
    code: "",
    password: "",
    passwordAgain: "",
  });
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const requestCode = async () => {
    try {
      setBusy(true);
      setError("");
      setMessage("");
      const result = await api("/auth/forgot-password", {
        method: "POST",
        body: JSON.stringify({ email: form.email }),
      });
      setMessage(result.message);
      setStep(2);
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  };

  const resetPassword = async () => {
    if (form.password !== form.passwordAgain) {
      setError("Yeni şifreler eşleşmiyor.");
      return;
    }
    try {
      setBusy(true);
      setError("");
      setMessage("");
      await api("/auth/reset-password", {
        method: "POST",
        body: JSON.stringify({ email: form.email, code: form.code, password: form.password }),
      });
      setMessage("Şifreniz değiştirildi. Giriş ekranına yönlendiriliyorsunuz.");
      setTimeout(() => navigate("/login"), 900);
    } catch (e) {
      setError(e.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <section className="px-5 md:px-10 py-12 flex justify-center">
      <div className="bg-white rounded-[2rem] shadow-soft p-6 sm:p-8 max-w-md w-full">
        <h1 className="text-3xl font-bold mb-2">Şifremi Unuttum</h1>
        <p className="text-stone-500 mb-6">
          {step === 1 ? "Hesabına kayıtlı e-posta adresini gir." : "E-postana gelen kodu ve yeni şifreni gir."}
        </p>
        {error && <div className="bg-red-50 text-red-600 p-3 rounded-xl mb-4">{error}</div>}
        {message && <div className="bg-emerald-50 text-emerald-700 p-3 rounded-xl mb-4">{message}</div>}
        <input
          value={form.email}
          onChange={(e) => setForm({ ...form, email: e.target.value })}
          placeholder="E-posta"
          type="email"
          disabled={step === 2}
          className="border disabled:bg-stone-100 p-3 rounded-xl w-full mb-3"
        />
        {step === 1 ? (
          <button onClick={requestCode} disabled={busy || !form.email} className="w-full bg-emerald-700 disabled:opacity-60 text-white py-3 rounded-xl">
            {busy ? "Gönderiliyor..." : "Doğrulama Kodu Gönder"}
          </button>
        ) : (
          <>
            <input value={form.code} onChange={(e) => setForm({ ...form, code: e.target.value })} placeholder="6 haneli doğrulama kodu" inputMode="numeric" className="border p-3 rounded-xl w-full mb-3" />
            <input value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="Yeni şifre" type="password" className="border p-3 rounded-xl w-full mb-3" />
            <input value={form.passwordAgain} onChange={(e) => setForm({ ...form, passwordAgain: e.target.value })} placeholder="Yeni şifre tekrar" type="password" className="border p-3 rounded-xl w-full mb-5" />
            <button onClick={resetPassword} disabled={busy} className="w-full bg-emerald-700 disabled:opacity-60 text-white py-3 rounded-xl">
              {busy ? "Değiştiriliyor..." : "Şifreyi Değiştir"}
            </button>
            <button onClick={requestCode} disabled={busy} className="w-full mt-3 border border-stone-300 disabled:opacity-60 py-3 rounded-xl">
              Kodu Tekrar Gönder
            </button>
          </>
        )}
        <p className="text-center text-sm mt-5"><Link to="/login">Girişe dön</Link></p>
      </div>
    </section>
  );
}
